"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _environment = _interopRequireDefault(require("../environment/environment"));

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var Basil = {};

if (_environment.default.isBrowser()) {
  Basil = require('basil.js');
}
/**
 * Utilities for saving and retrieving data from local/session storage as well as a cookie backup.
 * @module StorageUtils
 */


var StorageUtils = {
  /**
   * Sets a value in the selected storage type.
   * @static
   * @function set
   * @param {String} key - The key to save the value as.
   * @param {*} value - The value to set. Values will be run through `JSON.stringify()`.
   * @param {String} [type='local'] - The type of storage to use. Available types include 'local', 'session', and 'cookie'.
   * @param {Number} [cookieExpires=1] - Days when a cookie will expire if the type is set to 'cookie'.
   * @example
   * StorageUtils.set('foo', 'bar');
   * @returns {void}
   */
  set: function set(key, value) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'local';
    var cookieExpires = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    if (!_environment.default.isBrowser()) {
      return;
    }

    var val = (0, _stringify.default)(value);

    switch (type) {
      case 'local':
        Basil.localStorage.set(key, val);
        break;

      case 'session':
        Basil.sessionStorage.set(key, val);
        break;

      case 'cookie':
        Basil.cookie.set(key, val, {
          expireDays: cookieExpires
        });
        break;
    }
  },

  /**
   * Retrieves a value from the selected storage type.
   * @static
   * @function get
   * @param {String} key - The key to retrieve the value of. Values will be parsed using `JSON.parse()`.
   * @param {String} [type='local'] - The type of storage to retrieve from. Available types include 'local', 'session', and 'cookie'.
   * @example
   * StorageUtils.get('foo');
   * @returns {String} - The value at the specified key.
   */
  get: function get(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'local';

    if (!_environment.default.isBrowser()) {
      return;
    }

    var storageType;

    switch (type) {
      case 'local':
        storageType = 'localStorage';
        break;

      case 'session':
        storageType = 'sessionStorage';
        break;

      case 'cookie':
        storageType = 'cookie';
        break;
    } // wrap in a try/catch in case an already saved or old value is not JSON parseable


    try {
      return JSON.parse(Basil[storageType].get(key));
    } catch (err) {
      return Basil[storageType].get(key);
    }
  },

  /**
   * Removes a stored value from the specified storage type.
   * @static
   * @function remove
   * @param {String} key - The key of the value to remove.
   * @param {String} [type='local'] - The type of storage to remove from. Available types include 'local', 'session', and 'cookie'.
   * @example
   * StorageUtils.remove('foo');
   * @returns {void}
   */
  remove: function remove(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'local';

    if (!_environment.default.isBrowser()) {
      return;
    }

    var storageType;

    switch (type) {
      case 'local':
        storageType = 'localStorage';
        break;

      case 'session':
        storageType = 'sessionStorage';
        break;

      case 'cookie':
        storageType = 'cookie';
        break;
    }

    Basil[storageType].remove(key);
  }
};
var _default = StorageUtils;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Basil, "Basil", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/storage/storage.js");
  reactHotLoader.register(StorageUtils, "StorageUtils", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/storage/storage.js");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/storage/storage.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();